export default __webpack_public_path__ + "static/media/close.8954b98c.svg";